// Pages légales du site Qovoltis, les mêmes que dans l'application.
export const CGV_URL = "https://www.qovoltis.com/cgv";
export const PRIVACY_POLICY_URL = "https://www.qovoltis.com/politique-de-confidentialite";
